import { Close } from "@mui/icons-material";
import { Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import Styles from "./ViewDoc.module.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchViewDocumentHistory } from "../../../../Redux/Slices/bankingSlice";
import { ReactComponent as ViewIcon } from "../../../../assets/images/view.svg";
import { getDocumentUrlByLedgerId } from "../../../../Services/ApiCalling/banking";
import Loader from "../../../../commons/Loader/Loader";
import PreviewModal from "../../../../commons/PreviewModal/PreviewModal";

const ViewDoc = ({
  open,
  handleClose,
  connectionId,
  viewDocData,
  activeCounterparty,
}) => {
  const selfListingData = viewDocData?.[0]?.selfListing?.companyName;

  const dispatch = useDispatch();
  const { documentViewHistory, loading, error } = useSelector(
    (state) => state.bankingSlice,
  );

  useEffect(() => {
    if (connectionId) {
      dispatch(fetchViewDocumentHistory(connectionId));
    }
  }, [dispatch, connectionId]);

  const [previewModal, setPreviewModal] = useState(false);
  const [previewFileUrl, setPreviewFileUrl] = useState(null);
  const [selectedDocumentId, setSelectedDocumentId] = useState(null);

  const handleViewDoc = async (id) => {
    try {
      const response = await getDocumentUrlByLedgerId(id);
      const url = response.data;
      if (url) {
        setPreviewFileUrl(url);
        setSelectedDocumentId(id);
        setPreviewModal(true);
      } else {
        alert("Document URL not found");
      }
    } catch (err) {
      alert("Could not fetch document URL.");
    }
  };

  const handleClosePreview = () => {
    setPreviewModal(false);
    setPreviewFileUrl(null);
    setSelectedDocumentId(null);
  };
  const formatDocType = (type) => {
    if (!type) return "";
    if (type.toUpperCase() === "RANDOM") return "Others";
    return type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div className={`popupModal ${Styles.createEditModalCont}`}>
          <div
            className={`display_flex_row modalHeading ${Styles.modalHeading}`}
          >
            <div className="headingText">View Document</div>
            <Close
              style={{ fontSize: "24px", color: "#777777", cursor: "pointer" }}
              onClick={handleClose}
            />
          </div>
          <div className={Styles.docMainContainer}>
            <div className={`display_flex_row tableHeading ${Styles.docTable}`}>
              <div
                style={{
                  width: "15%",
                  textAlign: "left",
                  display: "flex",
                  justifyContent: "left",
                }}
              >
                Company Name
              </div>
              <div style={{ width: "20%" }}>Type</div>
              <div style={{ width: "20%" }}>Uploaded At</div>
              <div style={{ width: "20%" }}>File Name</div>
              <div
                style={{
                  width: "10%",
                  textAlign: "right",
                  display: "flex",
                  justifyContent: "right",
                }}
              >
                View
              </div>
            </div>
            <div className={Styles.docContent}>
              {loading ? (
                <div className={Styles.table_loader}>
                  <div className={Styles.loader_content}>
                    <div className={Styles.energy_core}>
                      <div className={Styles.ring}></div>
                      <div className={Styles.ring}></div>
                      <div className={Styles.ring}></div>
                    </div>
                  </div>
                </div>
              ) : error ? (
                <div className={Styles.error}>{error}</div>
              ) : documentViewHistory?.length > 0 ? (
                documentViewHistory.map((doc) => (
                  <div
                    className={`display_flex_row tableDetails ${Styles.docTable}`}
                    key={doc.id}
                  >
                    {" "}
                    <div style={{ width: "15%", textAlign: "left" }}>
                      {doc.companyName}
                    </div>
                    <div style={{ width: "20%" }}>
                      {" "}
                      {formatDocType(doc.documentType)}
                    </div>
                    <div style={{ width: "20%" }}>
                      {new Date(doc.createdAt).toLocaleString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                      })}
                    </div>
                    <div
                      style={{
                        maxWidth: "250px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        width: "20%",
                        cursor: "inherit",
                      }}
                      title={doc.filename}
                    >
                      {" "}
                      {doc.filename}
                    </div>
                    <div style={{ width: "10%", textAlign: "right" }}>
                      <ViewIcon onClick={() => handleViewDoc(doc?.id)} />
                    </div>
                  </div>
                ))
              ) : (
                <div
                  className={`display_flex_row_center ${Styles.noDataFound}`}
                >
                  No document history found
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal>
      <PreviewModal
        open={previewModal}
        onClose={handleClosePreview}
        fileUrl={previewFileUrl}
        disableDownload={true}
        documentId={selectedDocumentId}
      />
    </>
  );
};

export default ViewDoc;
